import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import {
  canonicalUrl,
  HOME_JSON_LD,
  isNoIndexPath,
  OG_IMAGE,
  PUBLIC_SEO,
  SITE_URL,
} from '../config/seo';
import { useLocale, t } from '../hooks/useT';

export function RouteSeo() {
  const { pathname } = useLocation();
  const { locale } = useLocale();
  const noindex = isNoIndexPath(pathname);
  const entry = PUBLIC_SEO[pathname];
  const canonical = canonicalUrl(pathname);

  const title = entry ? t(entry.titleKey) : 'Dezoom';
  const description = entry ? t(entry.descriptionKey) : t('seo.home.description');

  return (
    <Helmet htmlAttributes={{ lang: locale }}>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      {noindex ? (
        <meta name="robots" content="noindex, follow" />
      ) : (
        <meta name="robots" content="index, follow" />
      )}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={OG_IMAGE} />
      {pathname === '/' && (
        <script type="application/ld+json">
          {JSON.stringify(HOME_JSON_LD)}
        </script>
      )}
    </Helmet>
  );
}

/** Visible noscript fallback for crawlers that skip JS (supplement to prerender). */
export function SeoNoscriptFallback() {
  return (
    <noscript>
      <div className="seo-noscript">
        <h1>Dezoom — énigme photo quotidienne</h1>
        <p>{t('seo.home.description')}</p>
        <p>
          <a href={`${SITE_URL}/decouvrir`}>{t('nav.discover')}</a>
          {' · '}
          <a href={`${SITE_URL}/comment-jouer`}>{t('nav.howToPlay')}</a>
          {' · '}
          <a href={`${SITE_URL}/cgu`}>{t('legal.cgu')}</a>
        </p>
      </div>
    </noscript>
  );
}
